import React ,{useState} from 'react'
import axios from 'axios'
import { useParams, useNavigate, useLocation } from "react-router-dom"
import { Box, Typography, Grid, Tab, Tabs, BottomNavigation, BottomNavigationAction, Snackbar, Modal, Button, Alert, CircularProgress, TextareaAutosize } from '@mui/material'
import OrderInfo from './OrderInfo'
import globalStyles from '../../utils/globalStyles'
import { useRedirect, NullableBooleanInput } from 'react-admin'
import legolasApi from '../../api/legolas'
import OrderInvoiceList from './OrderInvoiceList'
import OrderCreditMemoList from './OrderCreditMemoList'
import OrderShipmentList from './OrderShipmentList'
import OrderReturnList from './OrderReturnList'
import theodenApi from '../../api/theoden'
import { has, size } from 'lodash'

function a11yProps(index) {
  return {
    id: `vertical-tab-${index}`,
    'aria-controls': `vertical-tabpanel-${index}`,
  };
}

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function OrderDetails(props) {

  const { state } = useLocation()
  const redirect = useRedirect()
  const navigate = useNavigate()

  const [orderNumber, setOrderNumber] = React.useState(null);
  const [data, setData] = React.useState(null)
  const [tabValue, setTabValue] = React.useState(0)
  const [value, setValue] = React.useState(0);
  const [hasInvoice, setHasInvoice] = React.useState(false)
  const [hasCreditMemo, setHasCreditMemo] = React.useState(false)
  const [datafromList, setDatafromList] = React.useState(null)
  const [openAlert, setOpenAlert] = React.useState(false)
  const [alertText, setAlertText] = React.useState('')
  const [alertSuccess, setAlertSuccess] = React.useState('')
  const [openSuccess, setOpenSuccess] = React.useState(false)
  const [hasShipment, setHasShipment] = React.useState(false)
  const { id } = useParams()
  const [loading, setLoading] = useState(false);

  const handleClose = () => setcustomerModal(false);
  const [customerModal, setcustomerModal] = React.useState(false);
  const [action, setAction] = React.useState("");
  const [resetModal, setresetModal] = React.useState(false);
  const [resetOpen, setResetOpen] = React.useState(false);
  const [open, setOpen] = React.useState(false);
  const [cancelOpen, setCancelOpen] = React.useState(false);
  const [EditOpen, setEditOpen] = React.useState(false);
  const [cancleModal, setCancleModal] = React.useState(false)
  const localStorageUser = localStorage.getItem('user');
	const user = JSON.parse(localStorageUser);
  const userChannels = Array.isArray(user?.channel) ? user.channel.map(String) : [];
  const userid = user.id;
  const userEmail = user?.email || "";
  const channelFilterQuery = userChannels.join(',');
  const [remarkModal, setRemarkModal] = useState(false);
  const [remark, setRemark] = useState("");
  const [remarkError, setRemarkError] = useState("");
  const location = useLocation();


  React.useEffect(() => {
    if (!id) return; // wait until id is available
    const orderId = id;
    
    axios.get(`${legolasApi.url}/orders/${orderId}?channelFilter=${channelFilterQuery}`).then((resp) => {
      console.log("resp1", resp);
      if(resp.data && resp.data.status){
        let bundleDiscount = 0.00;
        resp.data.data.items.forEach(element => {
          if(element.bundleAdditionalDiscount){
          bundleDiscount = bundleDiscount + (parseFloat(element.bundleAdditionalDiscount) * parseFloat(element.quantity));;
          }
        });
        resp.data.data.bundleDiscount = parseFloat(bundleDiscount);
        setData(resp.data.data);
        setOrderNumber(resp.data.data.summary.order_id);
        axios.post(`${legolasApi.url}/admin/check/invoice`, { orderId }).then((resp) => {
          console.log("resp2", resp);
          if(resp.data && resp.data.success && resp.data.hasInvoice){
            setHasInvoice(true);
          }
          if(resp.data && resp.data.success && resp.data.hasShipment){
            setHasShipment(true);
          }
        }).catch((error) => {
          console.log("Error in order detail while checking invoice where order id is", orderId, error);
        });
        
        axios.post(`${legolasApi.url}/admin/check/creditmemo`, { orderId }).then((resp) => {
          console.log("resp3", resp);
          if(resp.data && resp.data.success && resp.data.hasCreditMemo){
            setHasCreditMemo(true);
          }
        }).catch((error) => {
          console.log("Error in order detail while checking creditmemo where order id is", orderId, error);
        });
      }
    }).catch((error) => {
      console.log("Error in order detail where order id is", orderId, error);
     const statusCode = error?.response?.status;
  const message = error?.response?.data?.msg;

  if (statusCode === 403 && message) {
    setAlertText(message);
    setOpenAlert(true);
  } else {
    setAlertText("Something went wrong while fetching order details.");
    setOpenAlert(true);
  }
    });

    // const orderData = await axios.get(`${legolasApi.url}/orders/${orderId}`);
    // console.log("orderDetails", orderData.data);
    // if(orderData.data && orderData.data.status){
    //   setData(orderData.data.data);
    //   setOrderNumber(orderData.data.data.summary.order_id);
    //   const invoiceCheck = await axios.post(`${legolasApi.url}/admin/check/invoice`, { orderId });
    //   console.log("invoice check", invoiceCheck.data);
    //   if(invoiceCheck.data && invoiceCheck.data.success && invoiceCheck.data.hasInvoice){
    //     setHasInvoice(true);
    //   }
    //   if(invoiceCheck.data && invoiceCheck.data.success && invoiceCheck.data.hasShipment){
    //     setHasShipment(true);
    //   }
    //   const creditmemoCheck = await axios.post(`${legolasApi.url}/admin/check/creditmemo`, { orderId });
    //   console.log("credit memo check", creditmemoCheck.data);
    //   if(creditmemoCheck.data && creditmemoCheck.data.success && creditmemoCheck.data.hasCreditMemo){
    //     setHasCreditMemo(true);
    //   }
    // }
   
  }, [id, channelFilterQuery]);

  const tabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const handleInvoiceRedirect = (orderNo) => {
    const link = `/invoice/add/${orderNo}`
    navigate(link, { state: { data: data, type: 'invoice'} })
  }

  const handleCancelOrder = (orderNo) => {
    if (!remark.trim()) {
      handleAlertGen("Remark is required");
      return;
    }
    const payload = {
      orderId: orderNo.toString(),
      cancel_reason: remark,
      reason_source: "admin",
      email: userEmail,
      user_id: userid
    };
    setLoading(true); // Start loading spinner
    axios.post(`${legolasApi.url}/orders/cancel/order`, payload).then(res => {
      // console.log("Cancel order res:",res);
      if (res.status == 200) {
        const msg = res.data.msg;
        handleAlertSuccess(msg);
        setcustomerModal(false);
        setRemark("");
      } else {
        const msg = 'Some issue in cancel order';
        handleAlertGen(msg)
      }
    })
    .catch(error => {
      console.error("Error cancelling order:", error);
      handleAlertGen('Failed to cancel the order. Please try again.');
    })
    .finally(() => {
      setLoading(false); // Stop loading spinner
      setTimeout(() => {
        window.location.reload(); // Reload after operation
      }, 3000);
    });
};

  const handleShipmentRedirect = (orderNo) => {
    const doCheck = process.env.REACT_APP_DO_PICKERPACKER_CHECK
    if (!doCheck) {
      const link = `/shipment/add/${orderNo}`
      navigate(link, { state: { data: data, type: 'shipment' } })
    } else {
      axios.post(`${theodenApi.url}/pickerpacker-status`, { orderId : orderNo.toString() }).then(res => {
        const ppData = res.data
        console.log('data', ppData)
        if (ppData.success && has(ppData, 'pickerPackerCreated') && ppData.pickerPackerCreated) {
          const link = `/shipment/add/${orderNo}`
          navigate(link, { state: { data: data, type: 'shipment' } })
        } else if (ppData.success && has(ppData, 'pickerPackerCreated') && !ppData.pickerPackerCreated) {
          const msg = 'Please create Picker Packer before creating shipment'
          handleAlertGen(msg)
        } else {
          const msg = 'Order not found in Theoden'
          handleAlertGen(msg)
        }
      })
    }
  }
  const handleCreditMemoRedirect = (orderNo) => {
    const link = `/creditMemo/add/${orderNo}`
    navigate(link, { state: { data: data, type: 'creditMemo' } })
  }

  const handleReturnRedirect = (orderNo) => {

    axios.post(`${legolasApi.url}/admin/admin/canReturn`, { order_id : orderNo.toString() }).then(res => {
      const canReturnData = res.data
      console.log('canReturnData', canReturnData)
      if (canReturnData.success && has(canReturnData, 'can_return') && canReturnData.can_return) {
        const link = `/create-return/${orderNo}`
        navigate(link, { state: { data: data, type: 'return' }})
      } else if (canReturnData.success && has(canReturnData, 'can_return') && !canReturnData.can_return) {
        const msg = 'Return order already created, Please check!'
        handleAlertGen(msg)
      } else {
        const msg = 'Order not found in Theoden'
        handleAlertGen(msg)
      }
    })
  }
  const handleReOrderClick = (orderNo) => {
    
    const link = `/orders/order-create`
    navigate(link, { state: { data: orderNo } })
   
  }
  const handleChangeShipping = () => {
    const link = '/shipment/change-shipping'
    navigate(link, { state: {data: data }})
  }

  const handleAlertSuccess = (message) => {
    setAlertSuccess(message)
    setOpenSuccess(true)
    setTimeout(() => {
      setAlertSuccess('')
      setOpenSuccess(false)
    }, 3000)
  }

  const handleAlertGen = (message) => {
    setAlertText(message)
    setOpenAlert(true)
    setTimeout(() => {
      setAlertText('')
      setOpenAlert(false)
    }, 3000)
  }

  const closeSuccess = () => {
    setOpenSuccess(false)
  }

  const closeAlert = () => {
    setOpenAlert(false)
  }

 

  if (data == null) {
    return null
  }

  const handleAction = (status, action, orderNumber) => {
    setAction(action);
    if (action === "cancle") {
      setcustomerModal(status, orderNumber);
    }
    else if (action === "ok" || action === 'cancle') {
      setCancleModal(status, orderNumber)
    }
    else {
      setresetModal(status, orderNumber);
    }
  }

  
  const handleSnackClose = () => {
    setOpen(false);
    setCancelOpen(false);
    setResetOpen(false);
    setEditOpen(false)

  }

  return (
    
    <Box sx={{ width: '100%', height: 'auto', backgroundColor: '#fff !important', margin: '0px 20px' }}>
      <Snackbar open={openAlert} autoHideDuration={3000} onClose={closeAlert} anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
        <Alert onClose={closeAlert} severity="warning" sx={{ width: '400px', marginTop: '100px' }}>
          {alertText}
        </Alert>
      </Snackbar>
      <Snackbar open={openSuccess} autoHideDuration={3000} onClose={closeSuccess} anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
        <Alert onClose={closeSuccess} severity="success" sx={{ width: '400px', marginTop: '100px' }}>
          {alertSuccess}
        </Alert>
      </Snackbar>
      <Box sx={{
        display: 'flex', justifyContent: 'space-between', margin: '30px 20px',
        '& .MuiTypography-root': {
          fontSize: '2.5rem',
          fontWeight: 400,
          color: '#000'
        }
      }}>
        <Typography>#{orderNumber}</Typography>
      </Box>
      
      <BottomNavigation
        showLabels
        value={value}
        onChange={(event, newValue) => {
          setValue(newValue);
        }}
        sx={globalStyles.bottomNavigationMenu}>
        {/* <BottomNavigationAction label="Back" onClick={() => redirect('/orders')} /> */}
        <BottomNavigationAction label="Back" onClick={() => navigate(-1)} />
          {/* <BottomNavigationAction label="Back" onClick={handleBack} /> */}

        {
          !hasInvoice && data.summary.order_status != "CANCELLED" && userid != 155 &&
          <BottomNavigationAction label="Invoice" onClick={() => handleInvoiceRedirect(orderNumber)} sx={{ backgroundColor: globalStyles.colors.backgroundPrimary, color: '#fff !important' }}/>
        }
        {
          // (data.summary.order_status == "PENDING" && data.summary.fk_payment_id == 1) && !hasShipment && userid !== 155 &&

          ((data.summary.order_status == "PENDING" && data.summary.fk_payment_id == 1) || data.summary.order_status == "PROCESSING" || ( data.summary.order_status === "READY TO PICK-UP" && data.summary.delivery_method === "store_pickup")) && !hasShipment && userid !== 159 && userid !== 155 && userid !== 160 &&
          <BottomNavigationAction label="Cancel"
            onClick={() => {
              setcustomerModal(false);
              setRemarkModal(true);
            }}
            //onClick={() => handleAction(true, "cancle", orderNumber)} 
            sx={{ backgroundColor: globalStyles.colors.backgroundPrimary, color: '#fff !important' }} />
        }
        <Modal
          open={remarkModal}
          onClose={() => setRemarkModal(false)}
        >
          <Box sx={globalStyles.remarkModalContainer}>
            <Typography variant="h6">
              Cancellation Reason
              <span style={{ color: 'red' }}> *</span>
            </Typography>
            <TextareaAutosize
              minRows={4}
              maxRows={8}
              maxLength={255}
              placeholder="Enter the reason here..."
              value={remark}
              onChange={(e) => {
                const value = e.target.value;
                setRemark(value);
                const trimmed = value.trim();
                if (!trimmed) {
                  setRemarkError("Remark is required");
                } else if (trimmed.length < 10) {
                  setRemarkError("Cancellation reason must be at least 10 characters.");
                } else {
                  setRemarkError("");
                }
              }}
              style={{
                width: "100%",
                padding: "10px",
                marginTop: "15px",
                borderRadius: "6px",
                border: "1px solid #ccc"
              }}
            />
           
            <Typography
              variant="caption"
              sx={{
                display: "block",
                textAlign: "right",
                marginTop: "5px",
                color: remark.trim().length < 10 ? "red" : "text.secondary"
              }}
            >
              {remark.length}/255
            </Typography>
            {remarkError && (
          <Alert severity="error" sx={{ mt: 2 }}>
            {remarkError}
          </Alert>
        )}
            <Box sx={{
              display: 'flex', justifyContent: 'end', marginTop: '20px',
              '& .MuiButton-root': {
                color: '#2b3f7a !important',
                textTransform: 'capitalize'
              },
              '& .MuiButton-contained': {
                backgroundColor: '#2b3f7a !important',
                color: '#fff !important',
                textTransform: 'capitalize',
                '&:hover': {
                  backgroundColor: '#233566 !important'
                }
              }

            }}>
              <Button onClick={() => setRemarkModal(false)}>Cancel</Button>
              <Button onClick={() => setRemark("")}>Reset</Button>

              <Button
                variant="contained"
                onClick={() => {
                  const trimmedRemark = remark.trim();
                  if (!trimmedRemark || trimmedRemark.length < 10) {
                    return;
                  }
                  setRemarkError("");
                  setRemarkModal(false);
                  setTimeout(() => {
                    setcustomerModal(true);
                  }, 200);
                }}
              >
                Submit
              </Button>
            </Box>
          </Box>
        </Modal>
        {loading ? (
          <Box sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(255, 255, 255, 0.8)',
          }}>
            <CircularProgress />
          </Box>
        ) : (
          <Modal
            open={customerModal}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={globalStyles.modalContainer}>
              <Typography id="modal-modal-title" variant="h6" component="h2">
                Are you sure you want to cancel this order?
              </Typography>
              <Box sx={{
                display: 'flex', justifyContent: 'end', marginTop: '20px',
                '& .MuiButton-root': {
                  color: globalStyles.colors.backgroundPrimary,
                  textTransform: 'capitalize'
                }
              }}>
                <Button onClick={handleClose}>Cancel</Button>
                <Button onClick={() => {
                  handleCancelOrder(orderNumber);
                  setcustomerModal(false);
                }}>OK</Button>
              </Box>
            </Box>
          </Modal>
        )}
        {/* <Modal
          open={customerModal}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={globalStyles.modalContainer}>
            <Typography id="modal-modal-title" variant="h6" component="h2">
              Are you sure you want to cancel this order?
            </Typography>
            <Box sx={{
              display: 'flex', justifyContent: 'end', marginTop: '20px',
              '& .MuiButton-root': {
                color: globalStyles.colors.backgroundPrimary,
                textTransform: 'capitalize'
              }
            }}>
              <Button onClick={handleClose}>Cancel</Button>
              <Button onClick={() => handleCancelOrder(orderNumber)}>OK</Button>
            </Box>
          </Box>
        </Modal> */}
    
        <Snackbar open={resetOpen} autoHideDuration={3000} onClose={handleSnackClose} anchorOrigin={{ vertical: 'top', horizontal: 'center' }} >
          <Alert severity="success" sx={{ width: '400px', marginTop: '100px' }}>
            Order Cancelled Successfully
          </Alert>
        </Snackbar>

        
    
        {/*{ hasInvoice && !hasShipment && data.summary.order_status != "CANCELLED" &&
         <BottomNavigationAction label="Ship" onClick={() => handleShipmentRedirect(orderNumber)} sx={{ backgroundColor: globalStyles.colors.backgroundPrimary, color: '#fff !important' }}/>
       }*/}
    
        {
          hasInvoice && (data.summary.order_status == "CLOSED" || data.summary.order_status == "DELIVERED") && userid !== 159 && userid !== 155 && userid !== 160 && 
        <BottomNavigationAction label="Return" onClick={() => handleReturnRedirect(orderNumber)} sx={{ backgroundColor: globalStyles.colors.backgroundPrimary, color: '#fff !important' }}/>
        }
        {
         hasInvoice &&  !hasCreditMemo && (data.summary.order_status === "COMPLETE" || data.summary.order_status === "DELIVERED")&& userid !==159 && userid !== 155 && userid !== 160 &&
          <BottomNavigationAction label="Credit Memo" onClick={() => handleCreditMemoRedirect(orderNumber)} sx={{ backgroundColor: globalStyles.colors.backgroundPrimary, color: '#fff !important' }}/>
        }
        {  userid !== 159 && userid !== 155 && userid !== 160 && 
        <BottomNavigationAction label="Reorder" onClick={() => handleReOrderClick(orderNumber)} />}
      </BottomNavigation>
      {
       hasInvoice && !hasShipment &&
        <Box sx={{ fontSize: '20px', color: 'green', fontWeight: 600, margin: '20px' }}>
          NOTE: Invoice has been generated for this order.
        </Box>
      }
      {
         hasShipment &&
        <Box sx={{ fontSize: '20px', color: 'green', fontWeight: 600, margin: '20px' }}>
          NOTE: Shipment has been generated for this order.
        </Box>
      }
      { data.summary.bundleEcomId &&
        <Box sx={{ fontSize: '20px', color: 'green', fontWeight: 600, margin: '20px'}}>
        Bundle EcomId : {data.summary.bundleEcomId}
      </Box>
}
      
     
      <Box sx={{ flexGrow: 1 }}>
        <Grid container spacing={2} columns={24} sx={{ marginTop: '20px' }}>
          <Grid item xs={5}>
            <Tabs
              orientation="vertical"
              variant="scrollable"
              value={tabValue}
              onChange={tabChange}
              aria-label="Vertical tabs example"
              sx={{
                borderRight: 1, borderColor: 'divider',
                '& .MuiTab-root': {
                  color: '#000',
                },
                '& .MuiTab-root.Mui-selected': {
                  color: '#2b3f7a !important'
                }
              }}
            >
              <Tab label="Information" {...a11yProps(0)} />
              {userid !== 155 && (
             
              <Tab label="Invoices" {...a11yProps(1)} />
            
              )}
               {userid !== 155 && (
              <Tab label="Credit Memos" {...a11yProps(2)} />
               )}
              {userid !== 155 && (
              <Tab label="Shipments" {...a11yProps(3)} />
              )}
              {/* <Tab label="Comments History" {...a11yProps(4)} />
              <Tab label="Transactions" {...a11yProps(6)} /> */}
              {userid !== 155 &&(
              <Tab label="Returns" {...a11yProps(4)} />
              )}
              
            </Tabs>
          </Grid>
          <Grid item xs={19}>
            <TabPanel value={tabValue} index={0}>
              <OrderInfo onStatusUpdated={(updated) => setData(previous => ({
                ...previous,
                summary: { ...previous.summary, order_status: updated.status, order_status_id: updated.status_id }
              }))} data={data} datafromList={datafromList} hasCreditMemo={hasCreditMemo} hasInvoice={hasInvoice} hasShipment={hasShipment}/>
            </TabPanel>
            {userid !== 155 && (
            <>
            <TabPanel value={tabValue} index={1}>
              <OrderInvoiceList data={data} />
            </TabPanel>
            </>
            )}
            {userid !== 155 && (
            <>
            <TabPanel value={tabValue} index={2}>
            <OrderCreditMemoList data={data} />
            </TabPanel>
            </>)}
            {userid !== 155 && (
              <>
            <TabPanel value={tabValue} index={3}>
            <OrderShipmentList data={data} />
            </TabPanel>
            </>)}
            {/* <TabPanel value={tabValue} index={4}></TabPanel>
            <TabPanel value={tabValue} index={5}></TabPanel> */}
            {userid !== 155 && (
              <>
            <TabPanel value={tabValue} index={4}>
              <OrderReturnList data={data} />
            </TabPanel>
            </>)}
          </Grid>
        </Grid>
      </Box>
    </Box>
  )
}

export default OrderDetails